import React, { Component } from 'react';

// import Modal module
import ModalModule from '../modal';

// extract Modal component from Modal module
const { Modal } = ModalModule;

// eslint-disable-next-line react/prefer-stateless-function
export default class UpgradeDialog extends Component {
	render() {
		const { data: config, modalId } = this.props;

		const primaryButton = {
			type: config.primaryButtonType,
			text: 'Change Plan',
			onClick: config.handleChangePlan,
			dataqa: 'upgrade-change-plan-button',
		};

		const secondaryButton = {
			type: config.secondaryButton,
			text: 'Close',
			dataqa: 'upgrade-close-button',
		};

		return (
			<Modal
				modalId={modalId}
				className="upgrade-modal"
				header={config.title ? config.title : 'Upgrade Plan'}
				primaryButton={primaryButton}
				secondaryButton={secondaryButton}
			>
				<div className="body">
					<div className="content">
						{config.upgradeType === 'reports' && <ReportsUpgradeContent />}
						{config.upgradeType === 'createScanForm' && <ScanFormUpgradeContent />}
					</div>
				</div>
			</Modal>
		);
	}
}

const ReportsUpgradeContent = () => (
	<div>
		<p>
			Your plan does not provide access to our Reports feature. To add this feature, click on
			the Change Plan button below and select a plan where it is included.
		</p>
		<p>
			What are Reports?
			<br />
			With Stamps.com’s reports you get pre-designed postage spending and usage reports to
			gain insights into your business. Analyze your data by cost type, location, user, mail
			class, or cost code. View your data as a bar chart to see historical trends, a pie chart
			to see a snapshot in time, or export it and use your own charts. If you want to the
			detail behind the numbers you can easily drill down with just one click.
		</p>
		<div className="reports-background-image" />
		<p>Detailed reporting lets you: </p>
		<ul className="reports-upgrade-list">
			<li>Review your postage account and reconcile your purchases and expenses</li>
			<li>Analyze your total expenses by type: postage, account, supplies, or insurance</li>
			<li>See expenses by user or office</li>
			<li>Evaluate spending by mail class, special service, or cost code</li>
		</ul>
	</div>
);

const ScanFormUpgradeContent = () => (
	<div>
		<p>
			Your plan does not allow the use of SCAN forms. To add this feature, click on the Change
			Plan button below and select a plan where it is included.{' '}
		</p>
		<p>
			What are Scan Forms?
			<br />
			The Shipment Confirmation Acceptance Notice (SCAN) form ensures that your packages are
			scanned by the USPS when they are received so that your customer can feel confident that
			their package is on its way.
		</p>
		<p>
			Using Stamps.com you’ll be able to create a SCAN form with a single click. Then just
			hand the form to the clerk or mail carrier and they will scan the barcode on the form.
			This scan records an Acceptance event for all the packages associated with the form,
			without having to scan each package individually.
		</p>
	</div>
);
